import React from 'react';
import { connect } from 'react-redux';
import { closePopUp } from '../../actions/PopUpActions';
import styled from 'styled-components';
import {GlobalFunctions} from '../../GlobalFunctions'
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';



class PopUp extends React.Component {
    constructor(props) {
        super()
        this.state = {
           visible:false
        }
        this.key = GlobalFunctions.randomString()
    }

    componentDidMount() {
       setTimeout(()=>{
           this.setState({visible:true})
           
       },1)
    }

    
    render (){
        return ([
            <Bg style={{
                zIndex: this.props.zIndex+100,  
            }}/>,
            <Pop key={this.key} visible={this.state.visible} style={{
                zIndex: this.props.zIndex+100,
            }}>
                <IconButton className='float-end'  size="small" onClick={()=>this.props.closePopUp()} style={{
                   position: 'absolute',
                   right: 20,
                   zIndex: 5,
                   top: 20
                }}>
                    <CloseIcon fontSize="small" />
                </IconButton>
               {this.props.children}
            </Pop>
        ])
    }
}

const Pop = styled.div`
    position: fixed;
    left: 50%;
    transition: .6s cubic-bezier(.58,1.47,.37,.94);
    top: ${props=>props.visible?"50%":"51%"};
    opacity: ${props=>props.visible?"1":"0"};
    height: auto;
    background: #fff;
    width: max-content;
    max-width:90vw;
    max-height:90vh;
    overflow-y:auto;
    overflow-x:hidden;
    border-radius: 5px;
    box-shadow: 5px 20px 150px rgba(0,0,0,0.2);
    transform: translate(-50%,-50%);
    padding:25px;
    > .Content { 
        margin:20px;
     }; 
`
const Bg = styled.div`
position:fixed;
top:0px;
width:100vw;
height:100vh;
left:0px;
background:rgba(0,0,0,0);
`

const Close = styled.div`
    position: absolute;
    right: 20px;
    top: 18px;
    font-weight: 100;
    cursor: pointer;
    opacity: 0.3;
    transition: .3s;
    height: 20px;
    width: 20px;
    text-align: center;
    line-height: 19px;
    border-radius: 5px;
    box-shadow: 5px 2px 10px rgba(0,0,0,0);
    z-index:20;
    &:hover{
        opacity:1;
        background: rgb(250, 250, 250);
        box-shadow: 5px 2px 10px rgba(0,0,0,0.03);
    }
    &:active{
        font-size:9px
    }

`

const mapDispatchToProps = (dispatch) => {
    return {
        closePopUp: () => dispatch(closePopUp()), 
    };
  };

const mapStateToProps = (store) => {
    
    return {
    };
  };

export default connect(mapStateToProps,mapDispatchToProps)(PopUp);